// src/clientes/CrearCliente.jsx
import React, { useState } from "react";
import { Global } from "../helpers/Global";

// Toast
import { useToast } from "../hooks/useToast";

// ===== MUI =====
import {
  Box,
  Paper,
  Typography,
  Stack,
  TextField,
  Button,
} from "@mui/material";

export const CrearCliente = () => {
  const toast = useToast();

  // =========================
  // Estado
  // =========================
  const [nombre, setNombre] = useState("");
  const [codigo, setCodigo] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  // =========================
  // Submit
  // =========================
  const agregarCliente = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;

    if (!nombre.trim() || !codigo.trim()) {
      toast.warning("Debes indicar el nombre y el código del cliente.");
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await fetch(`${Global.url}clientes`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({
          nombre: nombre.trim(),
          codigo: codigo.trim(),
        }),
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        toast.error(data?.message || "No se pudo crear el cliente.");
        return;
      }

      toast.success("Cliente añadido correctamente.");

      // Reset
      setNombre("");
      setCodigo("");
    } catch (error) {
      console.error("Error al añadir cliente:", error);
      toast.error("Error de conexión al crear el cliente.");
    } finally {
      setIsSubmitting(false);
    }
  };

  // =========================
  // Render
  // =========================
  return (
    <Box className="appContainer">
      <Stack spacing={2}>
        {/* Cabecera */}
        <Box className="pageHeader">
          <Typography variant="h5" sx={{ fontWeight: 700 }}>
            Registrar Cliente
          </Typography>
        </Box>

        {/* ✅ Formulario single-column */}
        <Box className="contentContainer contentContainer--formSingle">
          <Paper sx={{ p: 2 }}>
            <Box component="form" onSubmit={agregarCliente}>
              <Stack spacing={2}>
                <TextField
                  label="Nombre del cliente"
                  value={nombre}
                  onChange={(e) => setNombre(e.target.value)}
                  required
                  autoComplete="off"
                />

                <TextField
                  label="Código del cliente"
                  value={codigo}
                  onChange={(e) => setCodigo(e.target.value)}
                  required
                  autoComplete="off"
                />

                {/* Botón alineado a la derecha, ancho controlado */}
                <Box sx={{ display: "flex", justifyContent: "flex-end", pt: 1 }}>
                  <Button
                    type="submit"
                    disabled={isSubmitting}
                    aria-busy={isSubmitting}
                    sx={{ height: 40, minWidth: 180 }}
                  >
                    {isSubmitting ? "Guardando..." : "Guardar Cliente"}
                  </Button>
                </Box>
              </Stack>
            </Box>
          </Paper>
        </Box>
      </Stack>
    </Box>
  );

};
